import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { QRCodeModule } from 'angularx-qrcode';

import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { NgaModule } from './theme/nga.module';
import { PagesModule } from './pages/pages.module';


import { HTTPHelperService } from './shared/http-helper.services';
import { SecureService } from './shared/secure.service';
import { AdminService } from './shared/admin.services';
import { LoggerService } from './shared/logger.service';
import { ConsoleLoggerService } from './shared/console-logger.service';
import { UploadService } from './shared/uploadService.service';
import { HttpErrorInterceptor } from './http.interceptor';
// import { ProgressReportComponent } from './pages/admin/progress-report/progress-report.component';

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgaModule.forRoot(),
    PagesModule,
    routing,
    NgbModule,
    MatSlideToggleModule,
    QRCodeModule
  ],
  providers: [HTTPHelperService, SecureService, AdminService, UploadService,
    {
      provide: LoggerService, useClass: ConsoleLoggerService
    }, { provide: LocationStrategy, useClass: PathLocationStrategy },{
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }],
})
export class AppModule { }
